class InfiniteScroll {
    constructor() {
        this.sentinel = document.getElementById('ProductGridSentinel');
        this.spinner = document.getElementById('InfiniteScrollSpinner');
        this.productGrid = document.getElementById('product-grid');
        this.paginationContainer = document.getElementById('PaginationContainer');

        if (!this.sentinel || !this.productGrid) return;

        this.isLoading = false;
        this.observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting && !this.isLoading) {
                    this.loadNextPage();
                }
            });
        }, {
            rootMargin: '200px', // Trigger slightly before the user reaches the bottom
        });

        if (this.paginationContainer) {
            this.paginationContainer.classList.add('hide');
        }

        this.observer.observe(this.sentinel);
    }

    async loadNextPage() {
        const nextLink = document.getElementById('NextPaginationLink');
        if (!nextLink || !nextLink.href) {
            this.observer.unobserve(this.sentinel);
            if (this.paginationContainer) this.paginationContainer.classList.add('hide');
            return;
        }

        this.isLoading = true;
        this.spinner.classList.remove('hide');

        const url = new URL(nextLink.href);
        const sectionId = this.productGrid.dataset.id;
        url.searchParams.set('section_id', sectionId);

        try {
            const response = await fetch(url);
            if (!response.ok) throw new Error('Network response was not ok');

            const htmlText = await response.text();
            const parser = new DOMParser();
            const doc = parser.parseFromString(htmlText, 'text/html');

            // Append new products
            const newProducts = doc.querySelectorAll('#product-grid > li');
            newProducts.forEach(product => {
                this.productGrid.appendChild(product);
            });

            // Update pagination
            const newPagination = doc.getElementById('PaginationWrapper');
            const currentPaginationWrapper = document.getElementById('PaginationWrapper');

            if (newPagination && currentPaginationWrapper) {
                currentPaginationWrapper.innerHTML = newPagination.innerHTML;
            } else if (currentPaginationWrapper) {
                currentPaginationWrapper.remove();
                this.observer.unobserve(this.sentinel);
            }

            // If no new next link, stop observing
            if (!doc.getElementById('NextPaginationLink')) {
                this.observer.unobserve(this.sentinel);
                if (this.paginationContainer) this.paginationContainer.classList.add('hide');
            }

        } catch (error) {
            console.error('Infinite scroll error:', error);
        } finally {
            this.isLoading = false;
            this.spinner.classList.add('hide');
        }
    }
}

// Initialize when the DOM is ready
document.addEventListener('DOMContentLoaded', () => {
    new InfiniteScroll();
});

// Re-initialize after facet filtration (since the section might be replaced)
document.addEventListener('facet-render', () => {
    new InfiniteScroll();
});
